export default __webpack_public_path__ + "static/media/scalemodal.5c4aede9.webp";